module.exports = __webpack_public_path__ + "static/media/gallery11.9f56a811.png";